module.exports = __webpack_public_path__ + "img/tab_create_nor.5a38cd49.png";